import React from "react";
import {
  FormDataConsumer,
  NumberInput,
  required
} from "react-admin";

const FinilisedPremiumInput = props => (
  <FormDataConsumer>
    {({ formData }) => {
      const isFinalised = Number(formData?.statusId) === 231;

      return (
        <NumberInput
          source="finalisedPremium"
          label="Finalised Premium"
          validate={isFinalised ? [required()] : []}
          disabled={!isFinalised}
          fullWidth
          formClassName={props.formClassName}
        />
      );
    }}
  </FormDataConsumer>
);

export default FinilisedPremiumInput;